let lecturerData = {};
let currentSortOrder = {}; // Track current sort order for each lecturer
let currentCategoryFilter = {}; // Track current category filter for each lecturer
let currentStatusFilter = {}; // Track current status filter for each lecturer (HKI tabs)

// Status label mapping for human-readable labels
const statusLabels = {
    draft: "Draft",
    submitted: "Diajukan",
    approved: "Disetujui",
    ongoing: "Sedang Berjalan",
    completed: "Selesai",
    cancelled: "Dibatalkan",
    rejected: "Ditolak",
    pending: "Menunggu",
    active: "Aktif",
    inactive: "Nonaktif",
};

// Function to get status label with fallback
function getStatusLabel(status) {
    if (!status) return "-";
    const lowerStatus = status.toLowerCase();
    return statusLabels[lowerStatus] || status;
}

// Check if dark mode is enabled
function isDarkMode() {
    return document.documentElement.classList.contains("dark");
}

async function toggleLecturerDetails(lecturerId) {
    const detailsDiv = document.getElementById(`details-${lecturerId}`);
    const button = document.getElementById(`btn-${lecturerId}`);
    const icon = button.querySelector("i");

    if (detailsDiv.classList.contains("hidden")) {
        // Show details
        detailsDiv.classList.remove("hidden");
        icon.className = "bi bi-chevron-up mr-1";
        button.innerHTML = '<i class="bi bi-chevron-up mr-1"></i>Tutup';

        // Load data if not already loaded
        if (!lecturerData[lecturerId]) {
            await loadLecturerData(lecturerId);
        }

        // Initialize sort order as newest for this lecturer
        currentSortOrder[lecturerId] = "newest";

        // Show research tab by default
        showTab(lecturerId, "research");
    } else {
        // Hide details
        detailsDiv.classList.add("hidden");
        icon.className = "bi bi-chevron-down mr-1";
        button.innerHTML =
            '<i class="bi bi-chevron-down mr-1"></i>Lihat Penelitian';
    }
}

async function loadLecturerData(lecturerId) {
    const contentDiv = document.getElementById(`tab-content-${lecturerId}`);
    try {
        const container = document.getElementById("lecturer-results-container");
        if (!container)
            throw new Error("Could not find lecturer results container.");

        const urlTemplate = container.dataset.apiUrlTemplate;
        if (!urlTemplate) throw new Error("API URL template is not defined.");

        const finalUrl = urlTemplate.replace(":id", lecturerId);
        const response = await fetch(finalUrl);

        if (!response.ok)
            throw new Error(
                `API request failed with status ${response.status}`,
            );

        const data = await response.json();
        lecturerData[lecturerId] = data;

        // Update counters
        document.getElementById(`research-count-${lecturerId}`).textContent =
            data.research.length;
        document.getElementById(`community-count-${lecturerId}`).textContent =
            data.community.length;
        document.getElementById(
            `hki-research-count-${lecturerId}`,
        ).textContent = data.hki_research.length;
        document.getElementById(`hki-patents-count-${lecturerId}`).textContent =
            data.hki_patents.length;
    } catch (error) {
        console.error("Error loading lecturer data:", error);
        if (contentDiv) {
            contentDiv.innerHTML = `<div class="text-center py-8"><p class="text-red-500">Gagal memuat data.</p></div>`;
        }
    }
}

function sortData(lecturerId, sortOrder) {
    const data = lecturerData[lecturerId];
    if (!data) return;

    // Update current sort order
    currentSortOrder[lecturerId] = sortOrder;

    // Update sort button styles
    const newestBtn = document.getElementById(`sort-newest-${lecturerId}`);
    const oldestBtn = document.getElementById(`sort-oldest-${lecturerId}`);

    if (newestBtn && oldestBtn) {
        if (sortOrder === "newest") {
            newestBtn.className =
                "flex-1 sm:flex-none px-3 py-2 text-xs font-medium rounded-md bg-orange-600 text-white hover:bg-orange-700 transition-colors cursor-pointer";
            oldestBtn.className =
                "flex-1 sm:flex-none px-3 py-2 text-xs font-medium rounded-md bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors cursor-pointer";
        } else {
            newestBtn.className =
                "flex-1 sm:flex-none px-3 py-2 text-xs font-medium rounded-md bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors cursor-pointer";
            oldestBtn.className =
                "flex-1 sm:flex-none px-3 py-2 text-xs font-medium rounded-md bg-orange-600 text-white hover:bg-orange-700 transition-colors cursor-pointer";
        }
    }

    // Get current active tab
    const tabs = ["research", "community", "hki_research", "hki_patents"];
    let activeTab = "";
    tabs.forEach((tab) => {
        const tabBtn = document.getElementById(`tab-${tab}-${lecturerId}`);
        if (tabBtn && tabBtn.classList.contains("bg-orange-600")) {
            activeTab = tab;
        }
    });

    if (activeTab) {
        showTab(lecturerId, activeTab);
    }
}

function filterByCategory(lecturerId, categoryValue, tabType) {
    // Update current category filter
    currentCategoryFilter[lecturerId] = categoryValue;

    // Re-render the current tab with new filter
    showTab(lecturerId, tabType);
}

function filterByStatus(lecturerId, statusValue, tabType) {
    // Update current status filter
    currentStatusFilter[lecturerId] = statusValue;

    // Re-render the current tab with new filter
    showTab(lecturerId, tabType);
}

// Main filter functions for research and community sections
function filterMainResearch(category) {
    // Update button styles
    const buttons = [
        "main-research-all",
        "main-research-drtpm",
        "main-research-internal",
        "main-research-hibah",
    ];
    const values = ["", "drtpm", "pendanaan_internal", "pendanaan_hibah"];

    buttons.forEach((buttonId, index) => {
        const btn = document.getElementById(buttonId);
        if (btn) {
            if (values[index] === category) {
                btn.className =
                    "flex-1 sm:flex-none px-3 py-2 text-xs font-medium rounded-md bg-orange-600 text-white hover:bg-orange-700 transition-colors cursor-pointer";
                // Update badge style for active button
                const badge = btn.querySelector("span");
                if (badge) {
                    badge.className =
                        "bg-orange-800 text-white px-1.5 py-0.5 rounded text-xs ml-1";
                }
            } else {
                btn.className =
                    "flex-1 sm:flex-none px-3 py-2 text-xs font-medium rounded-md bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors cursor-pointer";
                // Update badge style for inactive button
                const badge = btn.querySelector("span");
                if (badge) {
                    badge.className =
                        "bg-gray-300 dark:bg-gray-600 text-gray-700 dark:text-gray-300 px-1.5 py-0.5 rounded text-xs ml-1";
                }
            }
        }
    });

    // Filter table rows
    filterTable("research-table", "category", category);

    // Update visible count after filtering
    updateVisibleCount("research-table");
}

function sortMainResearch(order) {
    // Update button styles
    const newestBtn = document.getElementById("main-research-newest");
    const oldestBtn = document.getElementById("main-research-oldest");

    if (newestBtn && oldestBtn) {
        if (order === "newest") {
            newestBtn.className =
                "flex-1 sm:flex-none px-3 py-2 text-xs font-medium rounded-md bg-orange-600 text-white hover:bg-orange-700 transition-colors cursor-pointer";
            oldestBtn.className =
                "flex-1 sm:flex-none px-3 py-2 text-xs font-medium rounded-md bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors cursor-pointer";
        } else {
            newestBtn.className =
                "flex-1 sm:flex-none px-3 py-2 text-xs font-medium rounded-md bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors cursor-pointer";
            oldestBtn.className =
                "flex-1 sm:flex-none px-3 py-2 text-xs font-medium rounded-md bg-orange-600 text-white hover:bg-orange-700 transition-colors cursor-pointer";
        }
    }

    // Sort table rows
    sortTable("research-table", "year", order);
}

function filterMainCommunity(category) {
    // Update button styles
    const buttons = [
        "main-community-all",
        "main-community-drtpm",
        "main-community-internal",
        "main-community-hibah",
    ];
    const values = ["", "drtpm", "pendanaan_internal", "pendanaan_hibah"];

    buttons.forEach((buttonId, index) => {
        const btn = document.getElementById(buttonId);
        if (btn) {
            if (values[index] === category) {
                btn.className =
                    "flex-1 sm:flex-none px-3 py-2 text-xs font-medium rounded-md bg-orange-600 text-white hover:bg-orange-700 transition-colors cursor-pointer";
                // Update badge style for active button
                const badge = btn.querySelector("span");
                if (badge) {
                    badge.className =
                        "bg-orange-800 text-white px-1.5 py-0.5 rounded text-xs ml-1";
                }
            } else {
                btn.className =
                    "flex-1 sm:flex-none px-3 py-2 text-xs font-medium rounded-md bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors cursor-pointer";
                // Update badge style for inactive button
                const badge = btn.querySelector("span");
                if (badge) {
                    badge.className =
                        "bg-gray-300 dark:bg-gray-600 text-gray-700 dark:text-gray-300 px-1.5 py-0.5 rounded text-xs ml-1";
                }
            }
        }
    });

    // Filter table rows
    filterTable("community-table", "category", category);

    // Update visible count after filtering
    updateVisibleCount("community-table");
}

function sortMainCommunity(order) {
    // Update button styles
    const newestBtn = document.getElementById("main-community-newest");
    const oldestBtn = document.getElementById("main-community-oldest");

    if (newestBtn && oldestBtn) {
        if (order === "newest") {
            newestBtn.className =
                "flex-1 sm:flex-none px-3 py-2 text-xs font-medium rounded-md bg-orange-600 text-white hover:bg-orange-700 transition-colors cursor-pointer";
            oldestBtn.className =
                "flex-1 sm:flex-none px-3 py-2 text-xs font-medium rounded-md bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors cursor-pointer";
        } else {
            newestBtn.className =
                "flex-1 sm:flex-none px-3 py-2 text-xs font-medium rounded-md bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors cursor-pointer";
            oldestBtn.className =
                "flex-1 sm:flex-none px-3 py-2 text-xs font-medium rounded-md bg-orange-600 text-white hover:bg-orange-700 transition-colors cursor-pointer";
        }
    }

    // Sort table rows
    sortTable("community-table", "year", order);
}

// Generic table filtering function
function filterTable(tableId, column, value) {
    const table = document.getElementById(tableId);
    if (!table) return;

    const tbody = table.querySelector("tbody");
    if (!tbody) return;

    const rows = Array.from(tbody.querySelectorAll("tr"));

    rows.forEach((row) => {
        if (!value) {
            // Show all rows if no filter
            row.style.display = "";
        } else {
            // Get the data attribute or cell content based on column
            let cellValue = "";

            if (column === "category") {
                // For research and community tables, category is in the 4th column (index 3) - "Skema"
                const cells = row.querySelectorAll("td");
                if (cells.length > 3) {
                    cellValue = cells[3].textContent.trim().toLowerCase();
                }
            }

            // Map display text to database values and check multiple variations
            const categoryMap = {
                drtpm: ["drtpm"],
                pendanaan_internal: [
                    "pendanaan internal",
                    "internal",
                    "pendanaan_internal",
                ],
                pendanaan_hibah: [
                    "pendanaan hibah",
                    "hibah",
                    "pendanaan_hibah",
                ],
            };

            let shouldShow = false;
            if (!value || value === "") {
                shouldShow = true; // Show all when no filter
            } else {
                const searchTerms = categoryMap[value] || [value];
                shouldShow = searchTerms.some((term) =>
                    cellValue.toLowerCase().includes(term.toLowerCase()),
                );
            }

            row.style.display = shouldShow ? "" : "none";
        }
    });
}

// Generic table sorting function
function sortTable(tableId, column, order) {
    const table = document.getElementById(tableId);
    if (!table) return;

    const tbody = table.querySelector("tbody");
    if (!tbody) return;

    const rows = Array.from(tbody.querySelectorAll("tr"));

    rows.sort((a, b) => {
        let aValue = "";
        let bValue = "";

        if (column === "year") {
            // For research and community tables, year is in the 3rd column (index 2)
            const aCells = a.querySelectorAll("td");
            const bCells = b.querySelectorAll("td");

            if (aCells.length > 2 && bCells.length > 2) {
                aValue = parseInt(aCells[2].textContent.trim()) || 0;
                bValue = parseInt(bCells[2].textContent.trim()) || 0;
            }
        }

        if (order === "newest") {
            return bValue - aValue; // Descending
        } else {
            return aValue - bValue; // Ascending
        }
    });

    // Remove existing rows
    rows.forEach((row) => row.remove());

    // Append sorted rows
    rows.forEach((row) => tbody.appendChild(row));
}

// Function to update visible counts in filter buttons
function updateVisibleCount(tableId) {
    const table = document.getElementById(tableId);
    if (!table) return;

    const tbody = table.querySelector("tbody");
    if (!tbody) return;

    const allRows = Array.from(tbody.querySelectorAll("tr"));
    const visibleRows = allRows.filter((row) => row.style.display !== "none");

    // Update the "Semua" button count
    const prefix =
        tableId === "research-table" ? "main-research" : "main-community";
    const allButton = document.getElementById(`${prefix}-all`);
    if (allButton) {
        const badge = allButton.querySelector("span");
        if (badge) {
            badge.textContent = visibleRows.length;
        }
    }
}

function showTab(lecturerId, tabType) {
    const data = lecturerData[lecturerId];
    if (!data) return;

    // Update tab buttons
    const tabs = ["research", "community", "hki_research", "hki_patents"];
    tabs.forEach((tab) => {
        const tabBtn = document.getElementById(`tab-${tab}-${lecturerId}`);
        if (tabBtn) {
            if (tab === tabType) {
                tabBtn.className =
                    "tab-btn flex-1 py-2 px-2 sm:py-3 sm:px-4 text-xs sm:text-sm font-medium rounded-md transition-colors bg-orange-600 text-white";
                // Update active tab badge style
                const badge = tabBtn.querySelector("span:last-child");
                if (badge) {
                    badge.className =
                        "bg-orange-800 text-white px-1.5 py-0.5 sm:px-2 sm:py-1 rounded text-xs";
                }
            } else {
                tabBtn.className =
                    "tab-btn flex-1 py-2 px-2 sm:py-3 sm:px-4 text-xs sm:text-sm font-medium rounded-md transition-colors text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white";
                // Update inactive tab badge style
                const badge = tabBtn.querySelector("span:last-child");
                if (badge) {
                    badge.className =
                        "bg-gray-200 dark:bg-gray-600 px-1.5 py-0.5 sm:px-2 sm:py-1 rounded text-xs";
                }
            }
        }
    });

    // Update content
    const contentDiv = document.getElementById(`tab-content-${lecturerId}`);
    if (!contentDiv) return;

    let content = "";

    if (data[tabType] && data[tabType].length > 0) {
        // Add sort controls for research and community tabs
        if (tabType === "research" || tabType === "community") {
            const sortOrder = currentSortOrder[lecturerId] || "newest";
            content = `
                <div class="mb-4 bg-white dark:bg-gray-800 rounded-lg p-3 shadow-sm">
                    <div class="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4">
                        <!-- Filter Kategori -->
                        <div class="flex items-center gap-3">
                            <i class="bi bi-funnel text-gray-500 dark:text-gray-400"></i>
                            <div class="flex flex-wrap gap-2">
                                <button onclick="filterByCategory('${lecturerId}', '', '${tabType}')"
                                        id="category-all-${lecturerId}"
                                        class="px-3 py-2 text-xs font-medium rounded-md ${
                                            (currentCategoryFilter[
                                                lecturerId
                                            ] || "") === ""
                                                ? "bg-orange-600 text-white hover:bg-orange-700"
                                                : "bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600"
                                        } transition-colors cursor-pointer">
                                    Semua <span class="${
                                        (currentCategoryFilter[lecturerId] ||
                                            "") === ""
                                            ? "bg-orange-800 text-white"
                                            : "bg-gray-300 dark:bg-gray-600 text-gray-700 dark:text-gray-300"
                                    } px-1.5 py-0.5 rounded text-xs ml-1">${
                                        data.stats && data.stats[tabType]
                                            ? data.stats[tabType].total
                                            : data[tabType].length
                                    }</span>
                                </button>
                                <button onclick="filterByCategory('${lecturerId}', 'drtpm', '${tabType}')"
                                        id="category-drtpm-${lecturerId}"
                                        class="px-3 py-2 text-xs font-medium rounded-md ${
                                            (currentCategoryFilter[
                                                lecturerId
                                            ] || "") === "drtpm"
                                                ? "bg-orange-600 text-white hover:bg-orange-700"
                                                : "bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600"
                                        } transition-colors cursor-pointer">
                                    DRTPM <span class="${
                                        (currentCategoryFilter[lecturerId] ||
                                            "") === "drtpm"
                                            ? "bg-orange-800 text-white"
                                            : "bg-gray-300 dark:bg-gray-600 text-gray-700 dark:text-gray-300"
                                    } px-1.5 py-0.5 rounded text-xs ml-1">${
                                        data.stats && data.stats[tabType]
                                            ? data.stats[tabType].drtpm
                                            : 0
                                    }</span>
                                </button>
                                <button onclick="filterByCategory('${lecturerId}', 'pendanaan_internal', '${tabType}')"
                                        id="category-internal-${lecturerId}"
                                        class="px-3 py-2 text-xs font-medium rounded-md ${
                                            (currentCategoryFilter[
                                                lecturerId
                                            ] || "") === "pendanaan_internal"
                                                ? "bg-orange-600 text-white hover:bg-orange-700"
                                                : "bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600"
                                        } transition-colors cursor-pointer">
                                    Internal <span class="${
                                        (currentCategoryFilter[lecturerId] ||
                                            "") === "pendanaan_internal"
                                            ? "bg-orange-800 text-white"
                                            : "bg-gray-300 dark:bg-gray-600 text-gray-700 dark:text-gray-300"
                                    } px-1.5 py-0.5 rounded text-xs ml-1">${
                                        data.stats && data.stats[tabType]
                                            ? data.stats[tabType]
                                                  .pendanaan_internal
                                            : 0
                                    }</span>
                                </button>
                                <button onclick="filterByCategory('${lecturerId}', 'pendanaan_hibah', '${tabType}')"
                                        id="category-hibah-${lecturerId}"
                                        class="px-3 py-2 text-xs font-medium rounded-md ${
                                            (currentCategoryFilter[
                                                lecturerId
                                            ] || "") === "pendanaan_hibah"
                                                ? "bg-orange-600 text-white hover:bg-orange-700"
                                                : "bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600"
                                        } transition-colors cursor-pointer">
                                    Hibah <span class="${
                                        (currentCategoryFilter[lecturerId] ||
                                            "") === "pendanaan_hibah"
                                            ? "bg-orange-800 text-white"
                                            : "bg-gray-300 dark:bg-gray-600 text-gray-700 dark:text-gray-300"
                                    } px-1.5 py-0.5 rounded text-xs ml-1">${
                                        data.stats && data.stats[tabType]
                                            ? data.stats[tabType]
                                                  .pendanaan_hibah
                                            : 0
                                    }</span>
                                </button>
                            </div>
                        </div>

                        <!-- Sort Tahun -->
                        <div class="flex items-center gap-3">
                            <i class="bi bi-sort-down text-gray-500 dark:text-gray-400"></i>
                            <div class="flex gap-2">
                                <button onclick="sortData('${lecturerId}', 'newest')"
                                        id="sort-newest-${lecturerId}"
                                        class="px-3 py-2 text-xs font-medium rounded-md ${
                                            sortOrder === "newest"
                                                ? "bg-orange-600 text-white hover:bg-orange-700"
                                                : "bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600"
                                        } transition-colors cursor-pointer">
                                    Terbaru
                                </button>
                                <button onclick="sortData('${lecturerId}', 'oldest')"
                                        id="sort-oldest-${lecturerId}"
                                        class="px-3 py-2 text-xs font-medium rounded-md ${
                                            sortOrder === "oldest"
                                                ? "bg-orange-600 text-white hover:bg-orange-700"
                                                : "bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600"
                                        } transition-colors cursor-pointer">
                                    Terlama
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="overflow-x-auto"><table class="min-w-full divide-y divide-gray-200 dark:divide-gray-700">`;
        } else {
            content =
                '<div class="overflow-x-auto"><table class="min-w-full divide-y divide-gray-200 dark:divide-gray-700">';
        }

        if (tabType === "research") {
            // Filter data by category first
            const categoryFilter = currentCategoryFilter[lecturerId] || "";
            let filteredData = data[tabType];
            if (categoryFilter) {
                filteredData = data[tabType].filter(
                    (item) => item.category === categoryFilter,
                );
            }

            // Sort data based on current sort order
            const sortOrder = currentSortOrder[lecturerId] || "newest";
            const sortedData = [...filteredData].sort((a, b) => {
                if (sortOrder === "newest") {
                    return parseInt(b.year) - parseInt(a.year);
                } else {
                    return parseInt(a.year) - parseInt(b.year);
                }
            });

            content += `
                <thead class="bg-orange-100 dark:bg-orange-900/50">
                    <tr>
                        <th class="px-6 py-3 text-left text-xs font-medium text-orange-800 dark:text-orange-300 uppercase tracking-wider">Judul</th>
                        <th class="px-6 py-3 text-left text-xs font-medium text-orange-800 dark:text-orange-300 uppercase tracking-wider">Tahun</th>
                        <th class="px-6 py-3 text-left text-xs font-medium text-orange-800 dark:text-orange-300 uppercase tracking-wider">Skema</th>
                        <th class="px-6 py-3 text-left text-xs font-medium text-orange-800 dark:text-orange-300 uppercase tracking-wider">Status</th>
                    </tr>
                </thead>
                <tbody class="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">`;
            sortedData.forEach((item) => {
                content += `
                    <tr class="hover:bg-gray-50 dark:hover:bg-gray-700">
                        <td class="px-6 py-4 text-sm font-medium text-gray-900 dark:text-white">${
                            item.title
                        }</td>
                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-200">${
                            item.year
                        }</td>
                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-200">${
                            item.schema || "-"
                        }</td>
                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-200">${getStatusLabel(
                            item.status,
                        )}</td>
                    </tr>`;
            });
        } else if (tabType === "community") {
            // Filter data by category first
            const categoryFilter = currentCategoryFilter[lecturerId] || "";
            let filteredData = data[tabType];
            if (categoryFilter) {
                filteredData = data[tabType].filter(
                    (item) => item.category === categoryFilter,
                );
            }

            // Sort data based on current sort order
            const sortOrder = currentSortOrder[lecturerId] || "newest";
            const sortedData = [...filteredData].sort((a, b) => {
                if (sortOrder === "newest") {
                    return parseInt(b.year) - parseInt(a.year);
                } else {
                    return parseInt(a.year) - parseInt(b.year);
                }
            });

            content += `
                <thead class="bg-orange-100 dark:bg-orange-900/50">
                    <tr>
                        <th class="px-6 py-3 text-left text-xs font-medium text-orange-800 dark:text-orange-300 uppercase tracking-wider">Judul</th>
                        <th class="px-6 py-3 text-left text-xs font-medium text-orange-800 dark:text-orange-300 uppercase tracking-wider">Tahun</th>
                        <th class="px-6 py-3 text-left text-xs font-medium text-orange-800 dark:text-orange-300 uppercase tracking-wider">Skema</th>
                        <th class="px-6 py-3 text-left text-xs font-medium text-orange-800 dark:text-orange-300 uppercase tracking-wider">Status</th>
                    </tr>
                </thead>
                <tbody class="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">`;
            sortedData.forEach((item) => {
                content += `
                    <tr class="hover:bg-gray-50 dark:hover:bg-gray-700">
                        <td class="px-6 py-4 text-sm font-medium text-gray-900 dark:text-white">${
                            item.title
                        }</td>
                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-200">${
                            item.year
                        }</td>
                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-200">${
                            item.schema || "-"
                        }</td>
                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-200">${getStatusLabel(
                            item.status,
                        )}</td>
                    </tr>`;
            });
        } else if (tabType === "hki_research") {
            content += `
                <div class="mb-4 bg-white dark:bg-gray-800 rounded-lg p-3 shadow-sm">
                    <div class="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4">
                        <!-- Filter Status -->
                        <div class="flex items-center gap-3">
                            <i class="bi bi-funnel text-gray-500 dark:text-gray-400"></i>
                            <div class="flex flex-wrap gap-2">
                                <button onclick="filterByStatus('${lecturerId}', '', '${tabType}')"
                                        id="status-all-${lecturerId}"
                                        class="px-3 py-2 text-xs font-medium rounded-md ${
                                            (currentStatusFilter[lecturerId] ||
                                                "") === ""
                                                ? "bg-orange-600 text-white hover:bg-orange-700"
                                                : "bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600"
                                        } transition-colors cursor-pointer">
                                    Semua <span class="${
                                        (currentStatusFilter[lecturerId] ||
                                            "") === ""
                                            ? "bg-orange-800 text-white"
                                            : "bg-gray-300 dark:bg-gray-600 text-gray-700 dark:text-gray-300"
                                    } px-1.5 py-0.5 rounded text-xs ml-1">${
                                        data.stats && data.stats[tabType]
                                            ? data.stats[tabType].total
                                            : data[tabType].length
                                    }</span>
                                </button>
                                <button onclick="filterByStatus('${lecturerId}', 'Aktif', '${tabType}')"
                                        id="status-aktif-${lecturerId}"
                                        class="px-3 py-2 text-xs font-medium rounded-md ${
                                            (currentStatusFilter[lecturerId] ||
                                                "") === "Aktif"
                                                ? "bg-orange-600 text-white hover:bg-orange-700"
                                                : "bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600"
                                        } transition-colors cursor-pointer">
                                    Aktif <span class="${
                                        (currentStatusFilter[lecturerId] ||
                                            "") === "Aktif"
                                            ? "bg-orange-800 text-white"
                                            : "bg-gray-300 dark:bg-gray-600 text-gray-700 dark:text-gray-300"
                                    } px-1.5 py-0.5 rounded text-xs ml-1">${
                                        data.stats && data.stats[tabType]
                                            ? data.stats[tabType].active
                                            : 0
                                    }</span>
                                </button>
                                <button onclick="filterByStatus('${lecturerId}', 'Kadaluarsa', '${tabType}')"
                                        id="status-expired-${lecturerId}"
                                        class="px-3 py-2 text-xs font-medium rounded-md ${
                                            (currentStatusFilter[lecturerId] ||
                                                "") === "Kadaluarsa"
                                                ? "bg-orange-600 text-white hover:bg-orange-700"
                                                : "bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600"
                                        } transition-colors cursor-pointer">
                                    Kadaluarsa <span class="${
                                        (currentStatusFilter[lecturerId] ||
                                            "") === "Kadaluarsa"
                                            ? "bg-orange-800 text-white"
                                            : "bg-gray-300 dark:bg-gray-600 text-gray-700 dark:text-gray-300"
                                    } px-1.5 py-0.5 rounded text-xs ml-1">${
                                        data.stats && data.stats[tabType]
                                            ? data.stats[tabType].expired
                                            : 0
                                    }</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="overflow-x-auto"><table class="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                <thead class="bg-orange-100 dark:bg-orange-900/50">
                    <tr>
                        <th class="px-6 py-3 text-left text-xs font-medium text-orange-800 dark:text-orange-300 uppercase tracking-wider">Judul</th>
                        <th class="px-6 py-3 text-left text-xs font-medium text-orange-800 dark:text-orange-300 uppercase tracking-wider">Tanggal Expired</th>
                        <th class="px-6 py-3 text-left text-xs font-medium text-orange-800 dark:text-orange-300 uppercase tracking-wider">Status</th>
                    </tr>
                </thead>
                <tbody class="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">`;

            // Filter data by status first
            const statusFilter = currentStatusFilter[lecturerId] || "";
            let filteredData = data[tabType];
            if (statusFilter) {
                filteredData = data[tabType].filter(
                    (item) => item.status === statusFilter,
                );
            }

            filteredData.forEach((item) => {
                const expiredDate = item.expired_date
                    ? new Date(item.expired_date).toLocaleDateString("id-ID")
                    : "-";
                content += `
                    <tr class="hover:bg-gray-50 dark:hover:bg-gray-700">
                        <td class="px-6 py-4 text-sm font-medium text-gray-900 dark:text-white">${item.title}</td>
                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-200">${expiredDate}</td>
                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-200">${item.status}</td>
                    </tr>`;
            });
        } else if (tabType === "hki_patents") {
            content += `
                <div class="mb-4 bg-white dark:bg-gray-800 rounded-lg p-3 shadow-sm">
                    <div class="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4">
                        <!-- Filter Status -->
                        <div class="flex items-center gap-3">
                            <i class="bi bi-funnel text-gray-500 dark:text-gray-400"></i>
                            <div class="flex flex-wrap gap-2">
                                <button onclick="filterByStatus('${lecturerId}', '', '${tabType}')"
                                        id="status-all-${lecturerId}"
                                        class="px-3 py-2 text-xs font-medium rounded-md ${
                                            (currentStatusFilter[lecturerId] ||
                                                "") === ""
                                                ? "bg-orange-600 text-white hover:bg-orange-700"
                                                : "bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600"
                                        } transition-colors cursor-pointer">
                                    Semua <span class="${
                                        (currentStatusFilter[lecturerId] ||
                                            "") === ""
                                            ? "bg-orange-800 text-white"
                                            : "bg-gray-300 dark:bg-gray-600 text-gray-700 dark:text-gray-300"
                                    } px-1.5 py-0.5 rounded text-xs ml-1">${
                                        data.stats && data.stats[tabType]
                                            ? data.stats[tabType].total
                                            : data[tabType].length
                                    }</span>
                                </button>
                                <button onclick="filterByStatus('${lecturerId}', 'Aktif', '${tabType}')"
                                        id="status-aktif-${lecturerId}"
                                        class="px-3 py-2 text-xs font-medium rounded-md ${
                                            (currentStatusFilter[lecturerId] ||
                                                "") === "Aktif"
                                                ? "bg-orange-600 text-white hover:bg-orange-700"
                                                : "bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600"
                                        } transition-colors cursor-pointer">
                                    Aktif <span class="${
                                        (currentStatusFilter[lecturerId] ||
                                            "") === "Aktif"
                                            ? "bg-orange-800 text-white"
                                            : "bg-gray-300 dark:bg-gray-600 text-gray-700 dark:text-gray-300"
                                    } px-1.5 py-0.5 rounded text-xs ml-1">${
                                        data.stats && data.stats[tabType]
                                            ? data.stats[tabType].active
                                            : 0
                                    }</span>
                                </button>
                                <button onclick="filterByStatus('${lecturerId}', 'Kadaluarsa', '${tabType}')"
                                        id="status-expired-${lecturerId}"
                                        class="px-3 py-2 text-xs font-medium rounded-md ${
                                            (currentStatusFilter[lecturerId] ||
                                                "") === "Kadaluarsa"
                                                ? "bg-orange-600 text-white hover:bg-orange-700"
                                                : "bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600"
                                        } transition-colors cursor-pointer">
                                    Kadaluarsa <span class="${
                                        (currentStatusFilter[lecturerId] ||
                                            "") === "Kadaluarsa"
                                            ? "bg-orange-800 text-white"
                                            : "bg-gray-300 dark:bg-gray-600 text-gray-700 dark:text-gray-300"
                                    } px-1.5 py-0.5 rounded text-xs ml-1">${
                                        data.stats && data.stats[tabType]
                                            ? data.stats[tabType].expired
                                            : 0
                                    }</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="overflow-x-auto"><table class="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                <thead class="bg-orange-100 dark:bg-orange-900/50">
                    <tr>
                        <th class="px-6 py-3 text-left text-xs font-medium text-orange-800 dark:text-orange-300 uppercase tracking-wider">Judul</th>
                        <th class="px-6 py-3 text-left text-xs font-medium text-orange-800 dark:text-orange-300 uppercase tracking-wider">Jenis</th>
                        <th class="px-6 py-3 text-left text-xs font-medium text-orange-800 dark:text-orange-300 uppercase tracking-wider">Tanggal Expired</th>
                        <th class="px-6 py-3 text-left text-xs font-medium text-orange-800 dark:text-orange-300 uppercase tracking-wider">Status</th>
                    </tr>
                </thead>
                <tbody class="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">`;

            // Filter data by status first
            const statusFilter = currentStatusFilter[lecturerId] || "";
            let filteredData = data[tabType];
            if (statusFilter) {
                filteredData = data[tabType].filter(
                    (item) => item.status === statusFilter,
                );
            }

            filteredData.forEach((item) => {
                const expiredDate = item.expired_date
                    ? new Date(item.expired_date).toLocaleDateString("id-ID")
                    : "-";
                content += `
                    <tr class="hover:bg-gray-50 dark:hover:bg-gray-700">
                        <td class="px-6 py-4 text-sm font-medium text-gray-900 dark:text-white">${
                            item.title
                        }</td>
                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-200">${
                            item.type || "-"
                        }</td>
                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-200">${expiredDate}</td>
                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-200">${
                            item.status
                        }</td>
                    </tr>`;
            });
        }

        content += "</tbody></table></div>";
    } else {
        content = `
            <div class="text-center py-8">
                <i class="bi bi-inbox text-gray-400 dark:text-gray-500 text-3xl mb-2"></i>
                <p class="text-gray-500 dark:text-gray-400">Tidak ada data ${
                    tabType === "research"
                        ? "penelitian"
                        : tabType === "community"
                          ? "pengabdian"
                          : tabType === "hki_research"
                            ? "HKI penelitian"
                            : "HKI pengabdian"
                }</p>
            </div>`;
    }

    contentDiv.innerHTML = content;
}

// Search form validation
document.addEventListener("DOMContentLoaded", function () {
    const searchForm = document.querySelector('form[action*="search"]');
    const searchInput = document.querySelector('input[name="query"]');

    if (searchForm && searchInput) {
        searchForm.addEventListener("submit", function (e) {
            const query = searchInput.value.trim();

            // Prevent empty search
            if (!query || query.length === 0) {
                e.preventDefault();
                alert("Masukkan kata kunci pencarian minimal 2 karakter");
                searchInput.focus();
                return false;
            }

            // Validate minimum length
            if (query.length < 2) {
                e.preventDefault();
                alert("Pencarian minimal 2 karakter");
                searchInput.focus();
                return false;
            }
        });

        // Real-time validation
        searchInput.addEventListener("input", function () {
            const query = this.value.trim();
            const submitButton = searchForm.querySelector(
                'button[type="submit"]',
            );

            if (query.length === 0) {
                submitButton.disabled = true;
                submitButton.classList.add("opacity-50", "cursor-not-allowed");
            } else if (query.length < 2) {
                submitButton.disabled = true;
                submitButton.classList.add("opacity-50", "cursor-not-allowed");
                this.setCustomValidity("Minimal 2 karakter");
            } else {
                submitButton.disabled = false;
                submitButton.classList.remove(
                    "opacity-50",
                    "cursor-not-allowed",
                );
                this.setCustomValidity("");
            }
        });

        // Initialize button state
        const initialQuery = searchInput.value.trim();
        const submitButton = searchForm.querySelector('button[type="submit"]');
        if (initialQuery.length < 2) {
            submitButton.disabled = true;
            submitButton.classList.add("opacity-50", "cursor-not-allowed");
        }
    }
});

// Make functions globally available
window.toggleLecturerDetails = toggleLecturerDetails;
window.sortData = sortData;
window.filterByCategory = filterByCategory;
window.filterByStatus = filterByStatus;
window.filterMainResearch = filterMainResearch;
window.sortMainResearch = sortMainResearch;
window.filterMainCommunity = filterMainCommunity;
window.sortMainCommunity = sortMainCommunity;
window.showTab = showTab;
